import type { SVGProps } from 'react';
const SvgKeyboardCapslock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#keyboard_capslock_svg__a)">
      <path
        fill="currentColor"
        d="M12 8.41 16.59 13 18 11.59l-6-6-6 6L7.41 13 12 8.41ZM6 18h12v-2H6v2Z"
      />
    </g>
    <defs>
      <clipPath id="keyboard_capslock_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgKeyboardCapslock;
